"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extend = _interopRequireDefault(require("lodash/extend"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _keys = _interopRequireDefault(require("lodash/keys"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _emmett = _interopRequireDefault(require("emmett"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Dispatcher = /*#__PURE__*/function () {
  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    this.emitter = new _emmett.default();
    this.registeredActionsKeys = [];
  }

  _createClass(Dispatcher, [{
    key: "register",
    value: function register(actions, options) {
      var _this = this;

      if (!(0, _isArray.default)(actions)) {
        actions = [actions];
      }

      (0, _forEach.default)(actions, function (action) {
        // action registration should be unnecessary when actions are all registered by the top-level views in Mobx
        var actionKey = action.actionsKey && action.actionsKey();

        if (actionKey && _this.registeredActionsKeys.indexOf(actionKey) >= 0) {
          return;
        }

        if (options && options.autoBind === false) {
          _this.emitter.on(action.events());
        } else {
          // bind the dispatcher to action if it allows it
          if (action.onBind) {
            action.onBind(_this);
          }

          _this.registerEvents(action);
        }

        if (actionKey) {
          _this.registeredActionsKeys.push(actionKey);
        }
      });
    }
  }, {
    key: "registerEvents",
    value: function registerEvents(action) {
      var _this2 = this;

      var events = action.events();
      var eventNames = (0, _keys.default)(events); // Auto-bind event handlers to the action class that owns them.

      (0, _forEach.default)(eventNames, function (eventName) {
        var handler = events[eventName];

        if (handler) {
          _this2.emitter.on(eventName, handler.bind(action));
        } else {
          console.warn("Handler not defined for " + eventName);
        }
      });
    }
  }, {
    key: "emit",
    value: function emit(eventName, data) {
      this.emitter.emit(eventName, (0, _extend.default)({
        dispatcher: this
      }, data));
    }
  }]);

  return Dispatcher;
}();

var _default = Dispatcher;
exports.default = _default;